import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class ModeResolver implements Resolve<string> {
  resolve(route: ActivatedRouteSnapshot): string {
	console.log('ModeResolver running');
    return route.queryParamMap.get('m') || 'login';
  }
}